// extracted by mini-css-extract-plugin
export default {"backgroundColor":"Lobby_backgroundColor__AnIq3"};